import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import Leadership from "../../../components/Leadership";

const designationOrder = [
  "President",
  "Vice President (Membership)",
  "Vice President (Events)",
  "Vice President (Education)",
  "General Secretary",
  "Joint Secretary",
  "Treasurer",
  "Joint Treasurer",
];

const FaqMain = ({ leadershipRoles }) => {
  const items =
    leadershipRoles?.map((term) => {
      const sortedRoles = [...term.roles].sort((a, b) => {
        const indexA = designationOrder.findIndex((d) => d === a.designation);
        const indexB = designationOrder.findIndex((d) => d === b.designation);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        } else if (indexA !== -1) {
          return -1;
        } else if (indexB !== -1) {
          return 1;
        } else {
          return 0;
        }
      });

      const membersData = sortedRoles.map((role) => ({
        name: role.member?.name || "N/A",
        description: role.designation,
      }));

      const id = `${term._id.from}-${term._id.to}`;

      return {
        id,
        btnText: `${term._id.from} - ${term._id.to}`,
        description: membersData,
      };
    }) || [];

  return (
    <main>
      <Breadcrumb subtitle="About" title="Leadership" />

      <div className="it-faq-area p-relative pt-50 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-faq-wrap">
                <Leadership
                  itemClass="it-custom-accordion it-custom-accordion-style-3 inner-style"
                  items={items}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FaqMain;
